import { getFileContentType } from "./fileUtils";
import { checkUploadAborted, prepareUploadBody } from "./prepareUploadBody";

export const uploadFileToS3 = async (
  file: File,
  presignedUrl: string,
  signal: AbortSignal
) => {
  const contentType = getFileContentType(file);
  const body = await prepareUploadBody(file, contentType, signal);

  checkUploadAborted(signal);
  const response = await fetch(presignedUrl, {
    method: "PUT",
    body,
    headers: { "Content-Type": contentType },
    signal,
  });
  if (!response.ok) {
    throw new Error(`S3 upload failed (${response.status}). Please try again.`);
  }
};
